export default __webpack_public_path__ + "static/media/pic-2.022aa2ca.jpg";